// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_iB","advertCardFooter__row":"c-a_iC","advertCardFooter__name":"c-a_iE","advertCardFooter__price":"c-a_iF","advertCardFooter__age":"c-a_iG"};